import React from 'react';
import propTypes from 'prop-types';
import { ElasticInput } from 'reactstrap-elasticinput';
import { Input, Label, FormGroup } from 'reactstrap';

/**
 * render seo settings
 * @param {object} props - component props
 * @param {object} props.fields - seo fields
 * @param {Function} props.handleFieldChange - handle change to field
 * @param {Function} props.handleFieldUpdate - handle update when a user is finished typing
 * @param {Function} props.handleCheckedUpdate - handle update when a user is finished typing
 * @param {boolean} props.isReadonly - whether to render disabled inputs
 * @returns {React.Component} form fields
 */

const SeoSettings = ({
  fields,
  handleFieldChange,
  handleFieldUpdate,
  handleCheckedUpdate,
  isReadonly
}) => (
  <div className="px-4 p-2">
    <Label className="font-weight-bold" for="PageTitle">
      Page Title
    </Label>
    <ElasticInput
      disabled={isReadonly}
      data-test-id="seo-settings-page-title"
      id="PageTitle"
      name="PageTitle"
      onChange={handleFieldChange}
      onBlur={handleFieldUpdate}
      rows="1"
      value={fields.PageTitle}
    />
    <Label className="font-weight-bold" for="PageDescription">
      Page Description
    </Label>
    <ElasticInput
      disabled={isReadonly}
      data-test-id="seo-settings-page-description"
      id="PageDescription"
      name="PageDescription"
      onChange={handleFieldChange}
      onBlur={handleFieldUpdate}
      rows="1"
      value={fields.PageDescription}
    />
    <Label className="font-weight-bold" for="CanonicalUrl">
      Canonical URL
    </Label>
    <Input
      data-test-id="seo-settings-canonical-url"
      disabled={isReadonly}
      id="CanonicalUrl"
      name="CanonicalUrl"
      onChange={handleFieldChange}
      onBlur={handleFieldUpdate}
      type="text"
      value={fields.CanonicalUrl}
    />
    <FormGroup check inline>
      <Label className="font-weight-bold">
        <Input
          disabled={isReadonly}
          type="checkbox"
          name="isNoIndex"
          checked={fields.isNoIndex}
          data-test-id="seo-settings-is-no-index"
          onChange={handleCheckedUpdate}
        />
        Is No Index
      </Label>
    </FormGroup>
  </div>
);

SeoSettings.propTypes = {
  fields: propTypes.object.isRequired,
  handleFieldChange: propTypes.func.isRequired,
  handleFieldUpdate: propTypes.func.isRequired,
  handleCheckedUpdate: propTypes.func.isRequired,
  isReadonly: propTypes.bool
};

SeoSettings.defaultProps = {
  isReadonly: true
};

export default SeoSettings;
